import React from 'react';
import { Skeleton } from '@cargomatic/ui';
import { useOrderRateCards } from './hooks/useOrderRateCards';
import { handleDownloadRateCard } from 'utils/documentUtils';
export default function ShipperRateCardLink({ orderId, shipperId }) {
    var _a;
    const { data, isLoading } = useOrderRateCards(orderId, {
        shipperId,
    });
    return (React.createElement("div", { className: "mb-4 -mt-3" }, isLoading ? (React.createElement(Skeleton, { className: "h-4 w-44" })) : ((_a = data === null || data === void 0 ? void 0 : data.shipperRateCard) === null || _a === void 0 ? void 0 : _a.pdfUrl) ? (React.createElement("button", { type: "button", className: "text-sm text-blue-600 hover:underline", onClick: () => { var _a; return handleDownloadRateCard((_a = data.shipperRateCard) === null || _a === void 0 ? void 0 : _a.pdfUrl, true); } }, "Latest Shipper Rate Card")) : (React.createElement("span", { className: "text-sm text-red-600" }, "No rate card generated"))));
}
